/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  Typography,
  Box,
  Container,
  Card,
  Divider,
  Chip,
  CircularProgress,
} from "@mui/material";

import ButtonComponent from "components/Button";
import CustomTextField from "components/CustomTextField";
import { H2, H4, H5 } from "components/CustomTypography";
import { Notification } from "components/Atoms";
import ShopHeaderBack from "components/elements/main/ShopHeaderBack";
import CustomSectionCreator from "components/CustomSectionCreator";

import * as Actions from "actions/user/user.tryonpackages";
import * as ActionTypes from "constants/ActionTypes";
import {getPriceCurrency, getURI} from "helpers/utils";

import "./styles.scss";

const TryOnCheckout = (props) => {
  const history = useHistory();
  const location = useLocation();
  const selectedPackage = location.state?.selectedPackage;

  const [state, setState] = useState({
    coupon: "",
    payment_method: "razorpay",
  });

  const [isProcessing, setIsProcessing] = useState(false);

  const {
    isLoading,
    checkoutVerification,
    createdOrder,
    verifyTryOnCheckout,
    createTryOnOrder,
    completeTryOnOrder,
    paymentOrder,
    createTryOnPaymentOrder,
    verifyTryOnPayment,
    currency,
  } = props;

  useEffect(() => {
    if (!selectedPackage) {
      history.push(getURI(process.env.REACT_APP_TYPE, "credits_checkout", ""));
      return;
    }

    // Verify checkout on load
    verifyTryOnCheckout({
      package_id: selectedPackage._id,
      payment_method: state.payment_method,
    });
  }, [selectedPackage]);

  const sendNotification = (type, { title, description = "" }) => {
    Notification[type]({
      message: title,
      description,
    });
  };

  const handlePayment = () => {
    if (createdOrder && createdOrder.order._id) {
      createTryOnPaymentOrder({ order_id: createdOrder.order._id });
    }
  };

  useEffect(() => {
    if (props.serviceError) {
      const feedback = {
        title: "Error",
        description: props.serviceError.statusText || props.serviceError,
      };
      sendNotification("error", feedback);
      setIsProcessing(false);
    }

    switch (props.reqStatus) {
      case ActionTypes.VERIFY_TRYON_CHECKOUT_SUCCESS:
        break;
      case ActionTypes.CREATE_TRYON_ORDER_SUCCESS:
        if (createdOrder && createdOrder.order._id) {
          handlePayment(createdOrder);
        }
        break;
      case ActionTypes.CREATE_TRYON_PAYMENT_ORDER_SUCCESS:
        if (paymentOrder && paymentOrder.data) {
          handlePaymentProcessing(paymentOrder.data);
        }
        break;
      case ActionTypes.VERIFY_TRYON_PAYMENT_SUCCESS:
        setTimeout(() => {
          history.push(getURI(process.env.REACT_APP_TYPE, "mybag", ""));
        }, 1500);
        break;
      default:
        break;
    }
  }, [props.serviceError, props.reqStatus]);

  const handleCouponChange = (e) => {
    setState({ ...state, coupon: e.target.value });
  };

  const handleApplyCoupon = () => {
    if (state.coupon.trim()) {
      verifyTryOnCheckout({
        package_id: selectedPackage._id,
        coupon: state.coupon,
        payment_method: state.payment_method,
      });
    }
  };

  const handleRemoveCoupon = () => {
    setState({ ...state, coupon: "" });
    verifyTryOnCheckout({
      package_id: selectedPackage._id,
      payment_method: state.payment_method,
    });
  };

  const handleCheckout = () => {
    setIsProcessing(true);
    const orderData = {
      package_id: selectedPackage._id,
      payment_method: state.payment_method,
      platform: "web",
    };

    if (state.coupon.trim()) {
      orderData.coupon = state.coupon;
    }

    createTryOnOrder(orderData);
  };



  const handlePaymentVerification = (response) => {
    /*
    completeTryOnOrder({
      order_id: createdOrder.order_id,
      payment_id: response.razorpay_payment_id,
      payment_status: "completed",
    });

     */

    verifyTryOnPayment({
      razorpay_order_id: response.razorpay_order_id,
      razorpay_payment_id: response.razorpay_payment_id,
      razorpay_signature: response.razorpay_signature,
      order_id: createdOrder.order_id,
    });

  };

  const handlePaymentProcessing = (orderData) => {
    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID,
      amount: orderData.amount_due, // Convert to paise
      currency: "INR",
      name: "Shopana",
      image: "https://shopana.in/images/shopanaicon.png",
      description: `Try-On Credits Package`,
      order_id: orderData.id,
      handler: function(response) {
        handlePaymentVerification(response);
      },
      /*
      modal: {
        ondismiss: function() {
          setIsProcessing(false);
          sendNotification("info", {
            title: "Payment Cancelled",
            description: "You can complete the payment from your orders page.",
          });
        },
      },

       */
      theme: {
        color: "#FFFFFF",
      },
    };

    const rzp1 = new window.Razorpay(options);
    rzp1.open();
  };

  const renderPackageSummary = () => {
    if (!selectedPackage) return null;

    return (
      <Box>
        <CustomSectionCreator isSubtle={true} title="Package Details" />
        <Card sx={{ p: 3, mb: 3 }}>
          <Box display="flex" justifyContent="space-between" alignItems="flex-start">
            <Box>
              <H2 fontSize={18} mb={1}>
                {selectedPackage.title}
              </H2>
              <H4 fontSize={14} color="text.secondary" mb={2}>
                {selectedPackage.description}
              </H4>
              <Chip label={`${selectedPackage.credits} Credits`} color="primary" />
            </Box>
            <Box textAlign="right">
              <H2 fontSize={24}>
                {getPriceCurrency(selectedPackage.price, currency)}
              </H2>
              {selectedPackage.discount_percentage > 0 && (
                <H5
                  fontSize={14}
                  color="text.secondary"
                  sx={{ textDecoration: "line-through" }}
                >
                  {getPriceCurrency(selectedPackage.original_price, currency)}
                </H5>
              )}
            </Box>
          </Box>

          {selectedPackage.features && selectedPackage.features.length > 0 && (
            <Box mt={3}>
              <H5 fontSize={14} mb={1}>Features:</H5>
              {selectedPackage.features.map((feature, index) => (
                <Box key={index} display="flex" alignItems="center" mb={1}>
                  <Box component="span" mr={1} sx={{ color: "success.main" }}>
                    ✓
                  </Box>
                  <Typography variant="body2">{feature}</Typography>
                </Box>
              ))}
            </Box>
          )}
        </Card>
      </Box>
    );
  };

  const renderCouponSection = () => (
    <Box>
      <CustomSectionCreator isSubtle={true} title="Apply Coupon" />
      <Card sx={{ p: 3, mb: 3 }}>
        {checkoutVerification?.coupon?.code ? (
          <Box>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box>
                <Chip
                  label={`Coupon: ${checkoutVerification.coupon.code}`}
                  color="success"
                  size="medium"
                />
                <Typography variant="body2" color="success.main" sx={{ mt: 1 }}>
                  You saved {getPriceCurrency(checkoutVerification.coupon.discount, currency)}!
                </Typography>
              </Box>
              <ButtonComponent
                type="default"
                variant="outlined"
                name="Remove"
                size="small"
                onClick={handleRemoveCoupon}
              />
            </Box>
          </Box>
        ) : (
          <Box display="flex" gap={2}>
            <CustomTextField
              label="Coupon Code"
              value={state.coupon}
              onChange={handleCouponChange}
              fullWidth
              disabled={isLoading}
            />
            <ButtonComponent
              type="primary"
              variant="outlined"
              name="Apply"
              onClick={handleApplyCoupon}
              disabled={!state.coupon.trim() || isLoading}
            />
          </Box>
        )}
      </Card>
    </Box>
  );

  const renderPricingSummary = () => {
    if (!checkoutVerification) return null;

    const { order } = checkoutVerification;

    return (
      <Box>
        <CustomSectionCreator isSubtle={true} title="Price Summary" />
        <Card sx={{ p: 3, mb: 3 }}>
          <Box display="flex" justifyContent="space-between" mb={2}>
            <Typography>Original Price:</Typography>
            <Typography>
              {getPriceCurrency(order.original_price, currency)}
            </Typography>
          </Box>

          <Box display="flex" justifyContent="space-between" mb={2}>
            <Typography>Package Price:</Typography>
            <Typography>{getPriceCurrency(order.price, currency)}</Typography>
          </Box>

          {order.discount > 0 && (
            <Box display="flex" justifyContent="space-between" mb={2}>
              <Typography color="success.main">Discount:</Typography>
              <Typography color="success.main">
                -{getPriceCurrency(order.discount, currency)}
              </Typography>
            </Box>
          )}

          <Box display="flex" justifyContent="space-between" mb={2}>
            <Typography>Taxes:</Typography>
            <Typography>{getPriceCurrency(order.tax, currency)}</Typography>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Box display="flex" justifyContent="space-between">
            <H2 fontSize={18}>Total Amount:</H2>
            <H2 fontSize={18} color="primary">
              {getPriceCurrency(order.total, currency)}
            </H2>
          </Box>
        </Card>
      </Box>
    );
  };

  if (!selectedPackage) {
    return null;
  }

  return (
    <Container>
      <ShopHeaderBack onCancel={() => history.push(getURI(process.env.REACT_APP_TYPE, "credits_checkout", ""))} history={history} />
      <Box className="tryon-checkout-page" py={3}>
        <H2 fontSize={24} mb={3}>
          Checkout
        </H2>

        {renderPackageSummary()}
        {renderCouponSection()}
        {renderPricingSummary()}

        <Box mt={4}>
          <ButtonComponent
            type="primary"
            variant="contained"
            name={
              isProcessing ? (
                <Box display="flex" alignItems="center" gap={1}>
                  <CircularProgress size={20} color="inherit" />
                  Processing...
                </Box>
              ) : (
                "Proceed to Payment"
              )
            }
            size="large"
            fullWidth
            onClick={handleCheckout}
            disabled={isLoading || isProcessing || !checkoutVerification}
          />
        </Box>
      </Box>
    </Container>
  );
};

const mapStateToProps = ({ tryonPackages, bootupInfo }) => ({
  bootupInfo,
  currency: bootupInfo.symbol,
  reqStatus: tryonPackages.reqStatus,
  isLoading: tryonPackages.isLoading,
  serviceError: tryonPackages.serviceError,
  checkoutVerification: tryonPackages.checkoutVerification,
  createdOrder: tryonPackages.createdOrder,
  paymentOrder: tryonPackages.paymentOrder,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...Actions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TryOnCheckout);
